import { sdkRequest } from '@eb/http';
import { DEFAULT_DESTINATION_EXPANSIONS } from '@eb/event-renderer';

// Default page_size of search from search_service, we need
// to make sure we expand on the same number
const DEFAULT_SEARCH_PAGE_SIZE = 20;

const DEFAULT_EXPANSIONS = [
    'event_sales_status',
    'image',
    'primary_venue',
    'saves',
    'ticket_availability',
    'primary_organizer',
];

const DESTINATION_EVENTS_ENDPOINT = '/api/v3/destination/events/';

export const fetchEventExpansions = (
    eventIds = [],
    expansions = DEFAULT_DESTINATION_EXPANSIONS,
) => {
    const eventIdsJoined = eventIds.join(',');

    return sdkRequest(
        `${DESTINATION_EVENTS_ENDPOINT}?event_ids=${eventIdsJoined}&expand=${expansions}&page_size=${DEFAULT_SEARCH_PAGE_SIZE}`,
    );
};

export const fetchSearchEventExpansions = (eventIds) => {
    return fetchEventExpansions(eventIds, DEFAULT_EXPANSIONS);
};
